import cn from 'classnames';
import Link from 'next/link';
import { Check } from 'lucide-react';
import { useProductPageContext } from '@/components/v2/product/hooks/useProductPageContext';
import { ColorOptionProps } from '../types';
import { getContrastYIQ } from '@/lib/collections/helpers';

const ColorOption = ({
  isSelected,
  offer,
  value,
  hexValue,
  variantSlug,
}: ColorOptionProps) => {
  const { productId } = useProductPageContext();

  if (!hexValue) {
    return null;
  }

  const contrast = getContrastYIQ((hexValue ?? '#ffffff').replace('#', ''));

  const variantValue = value.displayValue ?? value.value;

  return (
    <div className="relative mt-1">
      <Link
        href={`/collections/${encodeURIComponent(
          productId,
        )}?skuId=${encodeURIComponent(offer.skuId)}`}
        scroll={false}
        shallow
        id={`e2e-pdp-${variantSlug}-${variantValue}`}
        aria-label={`Select ${variantValue} color`}
        className={cn(
          'border-offset-2 flex h-8 w-8 items-center justify-center rounded-full border focus:outline-none',
          {
            'border-slate-gray-200 hover:border-gray-700': !isSelected,
            'border-gray-700': isSelected,
          },
        )}
      >
        <div
          className="flex h-[26px] w-[26px] shrink-0 items-center justify-center rounded-full"
          // eslint-disable-next-line react/forbid-dom-props
          style={{ backgroundColor: hexValue }}
        >
          {isSelected && (
            <Check
              strokeWidth={3}
              className={cn('h-4 w-4', {
                'text-white': contrast === 'white',
                'text-gray-700': contrast === 'black',
              })}
            />
          )}
        </div>
      </Link>
    </div>
  );
};

export default ColorOption;
